"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogoAlias = void 0;
var getDarkColor = function (colors, brand) {
    switch (brand) {
        case 'valtra':
            return colors.primary.black;
        case 'massey':
            return colors.primary.grays[600];
        case 'agco':
        default:
            return colors.primary.grays[800];
    }
};
var getLogoAlias = function (globals, brand) {
    var colors = globals.colors;
    return {
        lightColor: colors.primary.white,
        darkColor: getDarkColor(colors, brand),
        brandColor: colors.primary.brand,
    };
};
exports.getLogoAlias = getLogoAlias;
